export default {
  farm: {
    locationType: "Tipo di Posizione",
    viewLocation: "Visualizza Posizione",
    Circular: "Circolare",
    Polygon: "Poligono",
    farmerId: "Farmer Id",
    farmAddress: "Farm Location Indirizzo",
    farmID: "ID azienda agricola",
    farmIdPlaceHolder: "Inserisci ID azienda",
    onTheFarm: "Sulla Fattoria",
    userRoles: "Ruoli utente",
    adduser: "Aggiungi utente",
    addAuser: "Aggiungi un utente",
    uploadUsers: "Carica gli utenti",
    addNewUser: "Aggiungi nuovo utente",
    selectDept: "Seleziona il Dipartimento",
    selectRole: "Selezionare Role",
    editUser: "Modifica utente",
    totalFarms: "Totale aziende agricole",
    NoAnimalsRegisteredForthisFarm:
      "Nessun animale è registrato per questo agriturismo",
    farmsPerPage: "Farms per pagina",
    regularFarms: "Farms regolari",
    farmRegisteredProducts: "Prodotti registrati",
    searchByFarmNameAndId: "Ricerca per Farm Name e Id",
    loadingProductsPleaseWait: "Caricamento prodotti... Aspetta",
    farmName: "Nome dell'azienda",
    nameOfTheFarm: "Nome della fattoria",
    farmLocation: "Location",
    productName: "Nome del prodotto",
    stockStatus: "Stato",
    inStock: "In magazzino",
    searchByProductName: "Ricerca per nome del prodotto",
    productCategory: "Categoria prodotto",
    products: "Prodotti",
    farms: "Aziende agricole",
    zones: "Zone",
    registerAfarm: "Registra un Agriturismo",
    govtRegistry: "Govt. Registro",
    cooperativeId: "ID cooperativo/unione",
    cooperativeName: "Nome cooperativo/unione",
    factory: "Fabbrica",
    farmType: "Tipo di azienda",
    contractMating: "Contratto di accoppiamento",
    customization: "Personalizzazione",
    recordsPerpage: "Registrazioni per Pagina",
    restoreDefault: "Ripristinare Default",
    apply: "Applicare",
    CommunityName: "Nome della Comunità",
    corporateName: "Nome aziendale",
    corporateRegistrationNum: "Registrazione aziendale No",
    corporateMailingAddress: "Corporate Mailing Indirizzo",
    communityName: "Nome della Comunità",
    searchState:
      "Ricerca per Farm ID, Registro di Gov., ID cooperativo, Tipo di azienda, Contratto",
    farmOwner: "Proprietario",
    govRegistrationNo: "Numero di registrazione Govt",
    farmInformation: "Informazioni sull'azienda",
    ownershipType: "Tipo di proprietà",
    farmLicenseInformation: "Informazioni sulla licenza",
    licenseNumber: "Numero di licenza",
    licenseExpiryDate: "Data di scadenza della licenza",
    regulatorName: "Nome del regolatore",
    regulatorRepresentativeName: "Regulator Representative Name",
    farmLocationSize: "Location & Size",
    productionSystem: "Sistema di allevamento",
    productionSystemNew: "Sistema di produzione",
    goals: "Obiettivo(i)",
    country: "Paese",
    state: "Stato",
    city: "Villaggio/Town/Città",
    gpsLocation: "Posizione GPS",
    latitude: "Latitudine",
    longitude: "Longitudine",
    farmNumber: "Numero di aziende",
    postal: "Codice Postale/Zip",
    houseNumber: "Numero della casa",
    farmRegistration: "Registrazione dell'azienda",
    cancel: "Annulla",
    register: "Registrazione",
    ok: "va bene",
    totalFarmSize: "Dimensione totale dell'azienda",
    farmGeographicLocation: "Farm Geographic Location",
    perimeterPointLongitude: "Perimetro Punto Longitudine",
    perimeterPointLatitude: "Latitudine del punto perimetro",
    perimeterPointLabel: "Etichetta del punto del perimetro",
    perimeterLength: "Lunghezza del perimetro",
    farmLatitude: "Agriturismo Latitudine",
    farmLongitude: "Agriturismo Longitudine",
    editFarm: "Modifica dell'articolo",
    update: "Aggiornamento",
    editAfarm: "Modificare una fattoria",
    nextFarm: "Il prossimo Agriturismo",
    nameoftheFarm: "Nome della Fattoria",
    addNewLocation: "Aggiungi nuova posizione",
    registerAProduct: "Registrare un prodotto",
    farmProducts: "Prodotti agricoli",
    steer: "Stereo",
    heifer: "Heifer",
    sire: "Sire",
    dam: "Dam",
    registerAnAnimal: "Registra un animale",
    farmAnimals: "Animali da fattoria",
    farm_type: "Tipo di azienda",
    farm_Owner: "Cimici della fattoria",
    dateOfRegistration: "Data di registrazione",
    dataIsNotAvailableForThisFarm:
      "Dati non disponibili per questo Agriturismo",
    registerNewProduct: "Registra un nuovo prodotto",
    information: "Informazioni",
    licenseInfo: "Informazioni sulla licenza",
    locationInfo: "Informazioni sulla località",
    geoLocation: "Geo Location",
    perimeterLengthState:
      "Lunghezza delle fattorie Perimetro (lunghezza delle pendici)",
    totalFarmSizeState: "Dimensione di un Agriturismo",
    productionSystemState: "Sistema di produzione utilizzato in azienda",
    contractMatingState:
      "Codice del programma di accoppiamento dei contratti in cui l'azienda partecipa.",
    ownershipTypeState: "Tipo di proprietà",
    regulatorRepresentativeNameState:
      "Nome della persona che rappresenta il regolatore che ha rilasciato la licenza",
    regulatorNameState: "Nome del regolatore che ha rilasciato la licenza",
    licenseExpiryDateState: "Data quando la licenza corrente è scaduta",
    licenseNumberState: "Numero di licenza rilasciato da Regolatore",
    plotNumberState: "Numero della fattoria.",
    plotNumber: "Numero di aziende",
    streetStatement: "Il nome della fattoria.",
    cityStatement: "Città in cui si trova l'agriturismo.",
    farmLocationAddressInfo:
      "Il luogo in cui l'azienda svolge la sua principale attività agricola.",
    provinceStateInfo:
      "Una divisione amministrativa principale di un paese o di un impero.",
    cityInfo:
      "Un insediamento umano raggruppato o comunità e edifici associati, più grande di un villaggio e più piccolo di una città, situato in una zona rurale.",
    streetNumberInfo: "Numero della strada",
    totalFarmSizeInfo: "Dimensione totale dell'azienda",
    areaUOMInfo:
      "L'unità di misura per le dimensioni dell'azienda, ad es. Ettaro, Acri ecc",
    perimeterLengthInfo: "Perimetro totale di Fattoria",
    permiterUOMInfo:
      "L'unità di misura per il perimetro dell'azienda, ad es. Centimetri, metri, ecc",
    stateStatement: "Regione del paese in cui si trova l'agriturismo.",
    countryState: "Paese in cui si trova l'agriturismo.",
    farmStateInfo: "Indirizzo della struttura",
    perimeterPointLongitudeState: "Longitudine di un punto in fattoria.",
    perimeterPointLatitudeState: "Latitudine di un punto in fattoria.",
    perimeterPointLabelState: "Etichetta di Punto.",
    farmLongitudeState: "Longitudine della fattoria.",
    farmLatitudeState: "Latitudine della fattoria.",
    deleteFarm: "Eliminare la fattoria",
    confirmBulkDeleteFarm:
      "Are you sure you want to delete {count} selected farm(s)?",
    selectFarmsToDelete: "Please select at least one farm to delete.",
    bulkDeleted: "{count} farm(s) have been deleted.",
    farmNameH: "Nome della fattoria",
    farmTypeH: "Il tipo dell'agriturismo dove si svolgono diverse attività.",
    farmOwnerH:
      "Nome del proprietario di una fattoria (auto-generate Farmer nome inserendo info)",
    ownershipTypeH:
      "Il tipo di agricoltori che possiedono / controllano la terra che coltivano e quelli che non lo fanno.",
    govtRegNumbH:
      "Numero di registro dell'agriturismo assegnato dal regolatore",
    contractMatingH:
      "Codice di contratto accoppiamento programmam che l'azienda partecipa a",
    productionSystemH:
      "Quale sistema di produzione viene utilizzato in azienda",
    cooperativeIDH: "ID di una cooperativa che l'azienda è membro",
    licenseNumberH:
      "Identificare il numero su una licenza rilasciata dal regolatore che lo identifica con il proprietario.",
    licenseExpiryDateH: "Data in cui la licenza corrente è scaduta",
    regularNameH: "Nome del regolatore che ha rilasciato la licenza",
    regularRepName:
      "Nome della persona che rappresenta il regolatore che ha rilasciato la licenza",
    countryH: "Paese in cui si trova l'agriturismo.",
    stateH: "Regione del paese in cui si trova l'agriturismo.",
    cityH: "Città in cui si trova l'agriturismo.",
    streetH: "Il nome della fattoria.",
    houseNumberH: "Numero della fattoria.",
    totalFarmSizeH:
      "Le dimensioni dell'agriturismo sono la somma di terreno che attualmente viene coltivata dall'azienda agricola che comprende terreni incolti ma escludendo terreni sotto vegetazione naturale, alberi o pascolo.",
    farmLatitudeH:
      "È la misura della distanza a nord o a sud dell'Equatore. Si misura con 180 linee immaginarie che formano cerchi intorno alla Terra est-ovest, paralleli all'Equatore",
    farmLongitudeH: "Misura distanza est o ovest del primo meridiano.",
    perimeterLengthH:
      "Lunghezza delle fattorie perimetrali (lunghezza massima)",
    perimeterPointLabelH:
      "Etichetta del punto. Utilizzando tre parametri (latitudine, longitudine ed etichetta) descriviamo il perimetro dell'azienda agricola e qualsiasi segmento all'interno dell'azienda.",
    perimeterPointLatH: "Latitudine di un punto in azienda",
    perimeterPointLongH: "Longitudine di un punto in fattoria",
    street: "Street",
    registration: {
      regulatorName: "Nome del regolatore che ha rilasciato la licenza",
      perimeterPointLabel:
        "Etichetta del punto. Utilizzando tre parametri (latitudine, longitudine ed etichetta) descriviamo il perimetro dell'azienda agricola e qualsiasi segmento all'interno dell'azienda.",
      perimeterPointLatitude: "Latitudine di un punto perimetrale",
      perimeterPointLongitude: "Longitudine di un punto perimetrale",
      farmID: "Il numero di identificazione dato all'allevamento",
      farmName: "Il nome dato alla fattoria del bestiame",
      CommunityName:
        "Un nome dato a un gruppo di persone con una caratteristica comune o un interesse che vivono insieme all'interno di una società più grande",
      farmType:
        "Il tipo di fattoria può essere classificato (gruppo) secondo il bestiame coltivato e come è coltivato",
      farmOwner:
        "Chiunque possieda o controlla le operazioni di un'azienda agricola",
      ownershipType:
        "Il tipo di agricoltori che possiedono / controllano l'azienda agricola e coloro che non fanno",
      govtRegistrationNumber:
        "Numero dato dall'organizzazione governativa in cui si registra l'azienda agricola",
      licenseNumber: "Numero di licenza rilasciato dal regolatore",
      licenseExpiryDate:
        "Il giorno in cui la licenza diventa invalida per il riconoscimento",
      regulatorRepresentativeName: "Nome del rappresentante del regolatore",
    },
    addFarm: "Aggiungi Agriturismo",
    importFarmsInBulk: "Importare aziende agricole in Bulk",
    importFarms: "Importazioni di aziende agricole",
    importingNote:
      "Il tuo file caricato è attualmente in fase di elaborazione.\nNon fare clic su cancellare, chiudere o aggiornare questa pagina per evitare interruzioni.",
    bulkImportNote:
      "Scaricare e utilizzare i modelli sottostanti per bulk import farm.",
    importantNoteDetail:
      "Si prega di utilizzare i modelli forniti sopra per i caricamenti in blocco. Altri formati porteranno al fallimento.",
    importCompleted: "Importazione completata",
    importantNote: "Nota importante",
    selectFileToUpload: "Seleziona il file per caricare i dati",
    farmerFirstName: "Farmer Primo Nome",
    farmerMiddleName: "Farmer medio nome",
    farmerLastName: "Farmer Ultimo nome",
    iAmNotFarmer: "Non sono il contadino",
    certifications: "Certifications",
    productionType: "Tipo di produzione",
    deleted: "Fattoria cancellato con successo.",
    notDeleted: "Fattoria non cancellata.",
    farmTitleDocument: "Titolo dell'azienda",
    dropHere: "oppure trascina e rilascia qui",
    technicianName: "Nome tecnico",
    farmRegistrationId: "Registrazione dell'azienda Id",
    farmerRegistrationId: "Registrazione Farmer Id",
    farmId: "Fattoria Id",
    farmerName: "Nome del coltivatore",
    farmOwnershipType: "Proprietà degli agricoltori Tipo",
    farmGoals: "Obiettivi agricoli",
    farmCertifications: "Certificazioni agricole",
    farmInfo: "Informazioni sull'azienda",
    provinceState: "Provincia/Stato",
    streetNumber: "Numero della strada",
    addGeofenceForThisFarm: "Aggiungi geofence per questo agriturismo",
    pleaseClickToChooseLocation: "Clicca per scegliere la posizione",
    address: "Indirizzo",
    geographicLocation: "Posizione geografica",
    searchLocation: "Ricerca",
    pleaseChooseOneOfTheOption: "Si prega di scegliere una delle opzioni",
    useGeoFencingFeature: "Utilizzare la funzione di geofetazione",
    uploadShapeFile: "Caricare un file di forma",
    uploadGeofence: "Caricamento in corso",
    upload: "Caricamento",
    reports: "Relazioni",
    avocado: "Avocado",
    avocadoTrees: "Alberi Avocado",
    addNewFarmLocation: "Aggiungi nuova fattoria Location",
    farmLocationAddress: "Farm Location Indirizzo",
    useGeofenceTool: "Utilizzare lo strumento di geofenza",
    geofenceIsRequiredForSatelliteReport:
      "Nota:La conoscenza è necessaria per i rapporti satellitari",
    enterHere: "Inserisci qui",
    primaryLocation: "Posizione primaria",
    secondaryLocation: "Posizione secondaria",
    locationAndSize: "Luogo e dimensione",
    farmReports: "Relazione(i)",
    deforestationReports: "Relazione sulla deforestazione(i)",
    id: "id",
    locationName: "Nome della posizione",
    createdAt: "Creato a",
    etherScanLink: "Link blockchain",
    overallProb: "Probabilità complessiva",
    addNewZone: "Aggiungi nuova zona",
    noZoneMessage: "Nessuna zona è stata ancora registrata.",
    noZoneRequest:
      "Clicca su Aggiungi nuova zona per creare una zona per questo agriturismo.",
    locationZone: "Ubicazione Zona",
    editFarmLocation: "Modificare Farm Location",
    addZone: "Aggiungi zona",
    nameOfTheZone: "Nome della zona",
    zoneDetails: "Dettagli zona",
    perimeter: "Perimetro",
    areaUnit: "Unità di area",
    area: "Settore",
    zoneName: "Nome della zona",
    farmGeofence: "Fattoria Geofence",
    circularGeofence: "Geofenza circolare",
    polygonGeofence: "Geofenza poligonale",
    radius: "Raggio",
    radiusInfo:
      "Specifica la distanza da un punto centrale al bordo esterno di un'area circolare.",
    radiusUnitInfo:
      "Si riferisce a una quantità standard utilizzata come base per la misurazione.",
    actions: "Azioni",
    editZone: "Modifica zona",
    numberOfGroups: "Numero di Gruppo",
    numberOfTrees: "Numero di alberi",
    group: "Gruppo",
    groupName: "Nome del gruppo",
    numberOfAnimals: "Numero di animali",
    status: "Stato",
    primaryGeofence: "Geofenza primaria",
    walkAndMeasure: "camminare e misurare",
    clearGeofence: "Geofenza chiara",
    deleteSelectedVertex: "Elimina Vertex selezionato",
    basicInformation: "Informazioni di base",
    geofenceCategoryName: "Geofence Categoria Nome",
    geofenceName: "Nome di Geofence",
    farmRadius: "Fattoria Radius",
    locationDisabledMessage:
      "La tua posizione è disattivata. Si prega di cercare la posizione da menu a sinistra.",
    yourDistanceIs: "La tua distanza è",
    searchFarmName: "Cerca per Nome della Fattoria",
    pleaseSelectFarmType: "Si prega di selezionare il tipo di Fattoria",

    organic: "Biologico",
    conventional: "Convenzionale",
    regBy: "Registrato da",
    regDate: "Data di registrazione",
    generateReport: "Genera rapporto",
    selectFarmToEnableCalendarView:
      "Per favore seleziona una fattoria per abilitare la vista del calendario",
    noFarm: "Nessuna fattoria registrata ancora.",
    noFarmDescription: "Per favore clicca sui pulsanti qui sotto per iniziare.",
    farmNameAndId: "Nome e ID della fattoria",
    grantAccess: "Concedi accesso",
    farmAccessGranted: "Accesso alla fattoria concesso",
    removeAccess: "Rimuovi accesso",
    removeFarmAccess: "Rimuovi accesso alla fattoria",
  },

  buySell: {
    farmerName: "Nome del coltivatore",
    location: "Location",
    country: "Paese",
    gender: "Genere",
    noOfOrdersSold: "Nessun ordine venduto",
    noOfPurchaseOrders: "Nessun ordine di acquisto",
    totalPurchaseSaleVolume: "Volume totale di vendita",
    totalAvgValue: "Valore totale di Avg",
    searchOrderByID: "Ordine di ricerca Per ID",
    totalNumberofOrders: "Numero totale di ordini",
    totalNumberOfTransactions: "Numero totale di operazioni",
    totalWeightOfTransactions: "Peso totale delle transazioni",
    totalMonetaryValue: "Totale monetario Valore",
    averagePrice: "Prezzo di Avgerage",
  },
  plantation: {
    farmerName: "Nome del coltivatore",
    phoneNumber: "Numero di telefono",
    plantationName: "Nome della piantagione",
    farm: "Fattoria",
    location: "Location",
    updatePlantationStatus: "Aggiornamento dello stato delle piante",
    update: "UPDATE",
    plantationStatus: {
      pending: "Finanziamenti",
      approved: "Approvazione",
      rejected: "Rifiuti",
      completed: "Completato",
    },
  },
};
